<div class="v4-header__info flex items-center gap-4">
    <a
        class="v4-header__info-link-static"
        [routerLink]="'/purchase/cart' | localize"
        attr.aria-label="{{ 'SHOPPING_CART_BASKET_ARIA_LABEL' | translate }} {{ getCount() }} {{
            'ITEMS_BASKET_ARIA_LABEL' | translate
        }}">
        <span class="v4-header__info-icon icon icon-basket hu-light:text-white pil-light-dark:text-secondary">
            <span class="v4-header__info-amount">{{ getCount() }}</span>
        </span>
    </a>
    <a class="v4-header__info-link-static flex gap-4" [routerLink]="'/purchase/cart' | localize"></a>
</div>
